(() => {
    "use strict"

    const button = document.getElementById('hero-video-playstate-button')

    if (document.getElementById('hero-carousel')) {
        new Splide('#hero-carousel', {
            type: 'loop',
            pagination: false,
            autoplay: true,
            autoplaySpeed: 10000,
            arrows: false,
        }).mount()
    }

    if (document.getElementById('sectors-carousel')) {
        new Splide('#sectors-carousel', {
            type: 'loop',
            pagination: false,
            fixedWidth: '420px',
            gap: 'clamp(1rem, 3.5vw, 2rem)',
            autoplay: false,
            breakpoints: {
                460: {
                    fixedWidth: '320px',
                }
            }
        }).mount()
    }

    if (document.getElementById('services-carousel')) {
        new Splide('#services-carousel', {
            type: 'loop',
            pagination: false,
            autoplay: true,
            autoplaySpeed: 3000,
            fixedWidth: '320px',
            gap: 'clamp(1rem, 3.5vw, 2rem)'
        }).mount()
    }

    if (document.getElementById('brands-carousel')) {
        new Splide('#brands-carousel', {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            arrows: false,
            pagination: false,
            perPage: 5,
            autoScroll: {
                speed: 1,
                pauseOnHover: true,
                pauseOnFocus: false,
            },
            breakpoints: {
                1300: {
                    perPage: 4,
                },
                1024: {
                    perPage: 3,
                },
                768: {
                    perPage: 2,
                },
                580: {
                    perPage: 1,
                }
            }
        }).mount(window.splide.Extensions)
    }

    if (button) {
        const playIcon = button.querySelector('[data-play]')
        const pauseIcon = button.querySelector('[data-pause]')
        const video = document.getElementById(button.dataset.video)

        if (playIcon && pauseIcon && video) {
            const updateIcons = () => {
                const isPlaying = !video.paused && !video.ended
                playIcon.style.display = isPlaying ? 'none' : 'inline-flex'
                pauseIcon.style.display = isPlaying ? 'inline-flex' : 'none'
            }

            video.addEventListener('play', updateIcons)
            video.addEventListener('pause', updateIcons)
            video.addEventListener('ended', updateIcons)

            button.addEventListener('click', () => {
                if (video.paused || video.ended) {
                    video.play()
                }
                else {
                    video.pause()
                }
            })

            updateIcons()
        }
    }
})()